"use client";

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
  useMemo,
} from "react";
import productColors from "@/mockDatas/productColors.json";
import {
  getProductHoverColor,
  getTabColor,
  TabIdentifier,
} from "@/utils/getProductColor";

interface ProductContextType {
  productConfig: any;
  setProductConfig: (config: any) => void;
  getTabColor: (
    identifier: TabIdentifier | string,
    sectorCode?: string
  ) => string;
  getProductColor: (product: any) => string;
}

const ProductContext = createContext<ProductContextType | null>(null);

interface ProductProviderProps {
  children: ReactNode;
  initialConfig?: any;
}

export function ProductProvider({
  children,
  initialConfig,
}: ProductProviderProps) {
  const [productConfig, setProductConfig] = useState<any>(
    initialConfig || productColors
  );

  // Đồng bộ khi initialConfig từ component cha thay đổi
  useEffect(() => {
    if (initialConfig) {
      setProductConfig(initialConfig);
    }
  }, [initialConfig]);

  const value = useMemo<ProductContextType>(
    () => ({
      productConfig,
      setProductConfig,
      getTabColor: (identifier: TabIdentifier | string, sectorCode?: string) =>
        getTabColor(identifier, productConfig, sectorCode),
      getProductColor: (product: any) =>
        getProductHoverColor(product, productConfig),
    }),
    [productConfig]
  );

  return (
    <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
  );
}

export function useProduct(): ProductContextType {
  const context = useContext(ProductContext);
  if (!context) {
    // Fallback an toàn nếu component không nằm trong Provider
    return {
      productConfig: productColors,
      setProductConfig: () => {},
      getTabColor: (identifier: TabIdentifier | string, sectorCode?: string) =>
        getTabColor(identifier, productColors, sectorCode),
      getProductColor: (product: any) =>
        getProductHoverColor(product, productColors),
    };
  }
  return context;
}
